import React from 'react';

export const ClimateCategory = (props) => (
    <svg {...props} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M23 4.7C23 4.8 23 4.9 23 5C23 6.1 22.1 7 21 7C19.9 7 19 6.1 19 5C19 3.9 19.9 3 21 3C21.1 3 21.2 3 21.3 3C19 1.1 16.1 0 13 0C5.8 0 0 5.8 0 13C0 20.2 5.8 26 13 26C20.2 26 26 20.2 26 13C26 9.8 24.9 6.9 23 4.7ZM18 11H14.5V18H11.5V11H8V8H11.5H14.5H18V11Z" />
    </svg>
);
export default ClimateCategory;
